export default __webpack_public_path__ + "static/media/unique_calls.b1e1b140.svg";